import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext, ModalContext } from '../../../components/contexts';
import ExpertAnalyzeController from '../../../controllers/expert/analyze/ExpertAnalyzeController';
import ValidateService from '../../../services/ValidateService';

import GbitGrid from '../../../components/gridComponents/GbitGrid';
import InputText from '../../../components/inputComponents/InputText';

const ExpertAnalyze = () => {
  const navigate = useNavigate();
  const store = useContext(GlobalContext);
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const gridRef = useRef(null);
  const [valueObj, setValueObj] = useState({
    requestName: '',
    taskName: '',
    processStatus: '',
  });
  const [selectBoxData, setSelectBoxData] = useState([]);

  const controller = useMemo(() => {
    return new ExpertAnalyzeController(
      store,
      modalService,
      validateService,
      [gridRef],
      { valueObj, setValueObj },
      { selectBoxData, setSelectBoxData },
      navigate
    );
  }, [store, modalService, validateService, navigate]);

  const onChange = (model, value) => {
    const temp = { ...valueObj };
    temp[model] = value;
    setValueObj(temp);
  };

  const handleSelect = e => {
    onChange('processStatus', e.target.value);
  };

  useEffect(() => {
    document.title = '전문가 분석 목록';
    controller.fnSearch();
    controller.fnGetStatusList();
  }, []);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">전문가 분석 목록</h2>
      </div>
      <div id="search-box" className="section">
        <div className="section__body">
          <div className="sch-option">
            {/*<dl className="sch-option__item">
              <dt>요청자</dt>
              <dd>
                <div className="input__wrap">
                  <InputText
                    id="eaRequestName"
                    model="requestName"
                    value={valueObj}
                    isRequired={true}
                    isReadonly={false}
                    phValue={'요청자'}
                    changeEvt={(model, value) => {
                      onChange(model, value);
                    }}
                    blurEvt={() => {}}
                  />
                </div>
              </dd>
            </dl>*/}
            <dl className="sch-option__item">
              <dt>공정명</dt>
              <dd>
                <div className="input__wrap">
                  <InputText
                    id="eataskName"
                    model="taskName"
                    value={valueObj}
                    isRequired={true}
                    isReadonly={false}
                    phValue={'공정명'}
                    changeEvt={(model, value) => {
                      onChange(model, value);
                    }}
                    blurEvt={() => {}}
                  />
                </div>
              </dd>
            </dl>
            <dl className="sch-option__item">
              <dt>상태</dt>
              <dd>
                <div className="input__select">
                  <select
                    aria-label="상태 선택"
                    onChange={handleSelect}
                    className="form-select sm"
                  >
                    <option value="">전체</option>
                    {selectBoxData.map((el, index) => (
                      <option key={el.seq} value={el.comCd}>
                        {el.comCdNm}
                      </option>
                    ))}
                  </select>
                </div>
              </dd>
            </dl>
            {/* <dl className="sch-option__item">
              <dt>AI 분석 완료</dt>
              <dd>
                <div className="input__wrap">
                  <input type="checkbox" id="dismatch" name="dismatch" />
                  <label for="dismatch"></label>
                </div>
              </dd>
              <dt>전문가 분석</dt>
              <dd>
                <div className="input__wrap">
                  <input type="checkbox" id="match" name="match" />
                  <label for="match"></label>
                </div>
              </dd>
            </dl> */}
          </div>
          <div className="btn-group">
            <button
              type="button"
              className="btn sm"
              onClick={() => {
                controller.fnSearch();
              }}
            >
              검색
            </button>
          </div>
        </div>
      </div>
      <div className="section section-table">
        <GbitGrid
          ref={gridRef}
          id="expertAnalyzeList"
          modalService={modalService}
          headerClick={controller.gridHeaderClick}
          cellClick={controller.gridCellClick}
          cellDblClick={controller.gridCellDblClick}
          caption="전문가 분석 목록의 No, 요청자, 공정명, 전문가, 요청일자, 시작일자, 완료일자, 상태의 정보를 나타내는 표입니다."
        />
      </div>
    </>
  );
};

export default ExpertAnalyze;
